import type React from 'react';
import { useScroll } from '@shared/hooks/use-scroll';
import * as st from './styles.module.scss';

type Props = {
  title: string;
  disableHideBehavior?: boolean;
};

export const PageTitle: React.FC<Props> = ({ title, disableHideBehavior = false }) => {
  const { transformHeader } = useScroll();

  return (
    <div
      className={st.header}
      style={
        disableHideBehavior
          ? { transform: 'translateY(0)' }
          : {
              transform: `${transformHeader}`,
              transition: 'transform 0.5s ease-in-out',
            }
      }
    >
      <span
        className={st.header__title}
        style={
          disableHideBehavior
            ? { opacity: '1', visibility: 'visible' }
            : {
                opacity: transformHeader !== 'translateY(0)' ? '0' : '1',
                transition: '1s  ease-in-out',
                visibility: transformHeader !== 'translateY(0)' ? 'hidden' : 'visible',
              }
        }
      >
        {title}
      </span>
    </div>
  );
};
